import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable"
import useFullPageLoader from "../../../hooks/useFullPageLoader"

import { v4 as uuidv4 } from "uuid";

function ListadoDevolucionesProveedores() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_TIPOS_TELAS = process.env.REACT_APP_URL_TIPOS_TELAS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;
  const URL_DEVOLUCIONES_PROVEEDORES = process.env.REACT_APP_URL_DEVOLUCIONES_PROVEEDORES;
  const URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS = process.env.REACT_APP_URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS;
  const URL_TELAS_OC = process.env.REACT_APP_URL_TELAS_OC;
  const URL_INVENTARIOS_TELAS = process.env.REACT_APP_URL_INVENTARIOS_TELAS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_TELAS_DEVOLUCIONES_PROVEEDORES = process.env.REACT_APP_URL_TELAS_DEVOLUCIONES_PROVEEDORES;

  const [compras, setCompras] = useState([]);
  const [devolucionesProveedores, setDevolucionesProveedores] = useState([]);
  const [telasOC, setTelasOC] = useState([]);
  const [ordenesSurtido, setOrdenesSurtido] = useState([]);
  const [selectedOrden, setSelectedOrden] = useState("");
  const [telas, setTelas] = useState([]);
  const [tipos_telas, setTiposTelas] = useState([]);
  const [selectedTiposTelasFiltro, setSelectedTiposTelasFiltro] = useState("");
  const [colores, setColores] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");

  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  
  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState("");

  const [fecha, setFecha] = useState("");
  const [pedimento, setPedimento] = useState("");
  const [factura_cliente, setFacturaCliente] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [partida, setPartida] = useState("");
  const [aduana, setAduana] = useState("");
  const [fecha_aduana, setFechaAduana] = useState("");
  const [pais_origen, setPaisOrigen] = useState("");
  const [numero_surtido, setNumeroSurtido] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [selectedClienteEdit, setSelectedClienteEdit] = useState("");

  const [telasSurtido, setTelasSurtido] = useState([]);
  const [modalEditTelas, setModalEditTelas] = useState(false);
  const toggleEditTelas = () => setModalEditTelas(!modalEditTelas);
  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  const [total_kilos_edit, setTotalKilosEdit] = useState(0);
  const [total_metros_edit, setTotalMetrosEdit] = useState(0);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      telasOC:"",
      telas: "",
      unidad: "",
      colores: "",
      cantidad: 0,
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [activo, setActivo] = useState('');

    //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50

  useEffect(() => {
    axios
      .get(URL_DEVOLUCIONES_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDevolucionesProveedores = response.data;
    // Array para pagination
    let arrayTabla = allDevolucionesProveedores
    .sort((a, b) => (a.idDevolucionProveedor > b.idDevolucionProveedor ? 1 : -1))
    .map((a) => {
      return {
        _id:a._id,
        fecha: a.fecha,
        user: a.user[0].nombre + " " + a.user[0].apellido,
        idUser: a.user[0]._id,
        compras: a.compras[0].idCompras,
        idCompra: a.compras[0]._id,
        // L73 (2026-06) — factura de la compra + empresa de la OC
        factura: a.compras[0].factura_proveedor || "",
        empresa: a.compras[0].ordenesCompra[0].empresa || "",
        proveedor: a.compras[0].ordenesCompra[0].proveedores[0].nombre_comercial,
        idProveedor: a.compras[0].ordenesCompra[0].proveedores[0]._id,
        tipo: a.compras[0].ordenesCompra[0].tipo,
        // TF7 — ¿la compra lleva IVA? (para mostrar IVA en el PDFOC)
        llevaIva: Number(a.compras?.[0]?.iva) > 0,
        observaciones: a.observaciones,
        numero: a.idDevolucionProveedor
      };
    }).filter(function (el) {
      return el != null;
    });

    let dataFinal = Object.values(arrayTabla);
    setDevolucionesProveedores(allDevolucionesProveedores);
    setComments(dataFinal)
    //

      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

  }, []);

  const ListaDevoluciones = comments.sort((a, b) =>
    a.idDevolucionProveedor > b.idDevolucionProveedor ? 1 : -1
  );


  function PDFTabla() {
    const data = ListaDevoluciones.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
            (selectedProveedor == 0 ||
              selectedProveedor == a.idProveedor)
      ) {
        return [
          a.fecha,
          a.proveedor,
          a.compras,
          a.user
         ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 20, 60, 25);
    doc.text(`Listado de Devoluciones Proveedores`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Fecha", "Proveedor", "Compra", "Devolvio"]],
      body: dataPDFLimpia,
      startY: 50,
    });
    doc.save(`DevolucionesProveedores.pdf`);
  }

  function excel() {
    const dataExcel = ListaDevoluciones.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
            (selectedProveedor == 0 ||
              selectedProveedor == a.idProveedor)
      ) {
        return {
          Fecha: a.fecha,
          Proveedor: a.proveedor,
          Compra: a.compras,
          Devolvio: a.user
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoDevolucionesProveedores";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoDevoluciones",
        sheetFilter: ["Fecha", "Proveedor", "Compra", "Devolvio"],
        sheetHeader: ["Fecha", "Proveedor", "Compra", "Devolvio"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = ListaDevoluciones.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
            (selectedProveedor == 0 ||
              selectedProveedor == a.idProveedor)
      ) {
        return [
          a.fecha,
          a.proveedor,
          a.compras,
          a.user
         ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 20, 60, 25);
    doc.text(`Listado de Devoluciones`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Fecha", "Proveedor", "Compra", "Devolvio"]],
      body: dataPDFLimpia,
      startY: 50,
    });
    var att = doc.output("arraybuffer");
    var base64File = doc.output("datauristring").split(",")[1];

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Devoluciones Proveedores",
          email: mailTo,
          fileName: "ListadoDevolucionesProveedores.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Devoluciones a Proveedores.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }



 async function PDFOC(
  fecha,
  idProveedor,
  proveedor,
  observaciones,
  numero,
  idPDFOC,
  user,
  surtidos,
  tipo,
  // L73 (2026-06)
  factura = "",
  empresa = "",
  // TF7 — si la compra lleva IVA, se agrega el renglón de IVA en el resumen
  llevaIva = false
 ) {
  // === L75 (2026-06) — Mismo PDF que Admin con precio/total + logo aspect ratio ===
  const brandColor = [42, 90, 138];
  const lightBg = [245, 247, 250];
  const borderColor = [210, 216, 224];
  const labelColor = [110, 120, 135];
  const stripeBg = [251, 252, 253];

  const isTela = tipo === "Tela";
  const fmtMoney = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(n) || 0);

  try {
    // Uso el endpoint Acumulados (igual que Admin) para tener costo en ambos tipos
    const { data: lista } = await axios.get(
      `${URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS}/devolucionProveedor/${idPDFOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    let dataFinal;
    if (isTela) {
      dataFinal = (lista || [])
        .map((a) => {
          const tela = a.telas?.[0] || {};
          const cant = Number(a.cantidad) || 0;
          const costo = Number(a.costo) || 0;
          const precio = cant > 0 ? +(costo / cant).toFixed(2) : 0;
          return {
            descripcion: `${tela.codigo || ""} ${tela.nombre || ""}`.trim(),
            unidad: tela.unidad || "",
            cantidad: cant,
            precio,
            total: costo,
          };
        })
        .filter((x) => x && x.cantidad > 0);
    } else {
      dataFinal = (lista || [])
        .map((a) => {
          const hab = a.habilitacion?.[0] || {};
          const cant = Number(a.cantidad) || 0;
          const precio = Number(a.costo) || 0;
          return {
            descripcion: `${hab.nombre || ""} ${hab.descripcion || ""}`.trim(),
            unidad: hab.unidad || "",
            cantidad: cant,
            precio,
            total: +(precio * cant).toFixed(2),
          };
        })
        .filter((x) => x && x.cantidad > 0);
    }

    const totalCantidad = dataFinal.reduce(
      (t, c) => t + (parseFloat(c.cantidad) || 0),
      0
    );
    const totalImporte = dataFinal.reduce(
      (t, c) => t + (parseFloat(c.total) || 0),
      0
    );
    // Mantengo seteo de estados externos para que otros lugares del listado los vean
    setTotalMetrosEdit(
      dataFinal
        .filter((e) => e.unidad === "Metros")
        .reduce((t, c) => t + (parseFloat(c.cantidad) || 0), 0)
    );
    setTotalKilosEdit(
      dataFinal
        .filter((e) => e.unidad === "Kilos")
        .reduce((t, c) => t + (parseFloat(c.cantidad) || 0), 0)
    );

    // L76 (2026-06) — Unidad junto a Cantidad también en Tela
    const bodyTabla = dataFinal.map((a) => [
      a.descripcion,
      new Intl.NumberFormat("en-US").format(a.cantidad),
      a.unidad,
      fmtMoney(a.precio),
      fmtMoney(a.total),
    ]);

    const doc = new jsPDF({ orientation: "landscape" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 15;

    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setFontSize(9);
      doc.setTextColor(...labelColor);
      doc.text(String(label || ""), lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(10);
      doc.text(String(value || "—"), valX, y);
    };

    // Header: logo izq con aspect ratio + título azul + línea
    try {
      const img = new Image();
      img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
      await new Promise((resolve) => {
        img.onload = () => {
          const maxH = 18;
          const scale = maxH / img.height;
          doc.addImage(
            img,
            "png",
            marginLeft,
            6,
            img.width * scale,
            maxH
          );
          resolve();
        };
        img.onerror = () => resolve();
      });
    } catch (e) {}

    doc.setFont(undefined, "bold");
    doc.setFontSize(16);
    doc.setTextColor(...brandColor);
    doc.text(
      `DEVOLUCIÓN PROVEEDOR # ${numero}`,
      pageWidth - marginLeft,
      18,
      { align: "right" }
    );
    doc.setDrawColor(...brandColor);
    doc.setLineWidth(0.6);
    doc.line(marginLeft, 30, pageWidth - marginLeft, 30);
    doc.setTextColor(0);
    doc.setLineWidth(0.2);
    doc.setDrawColor(0);

    // Card 2 columnas
    const cardY = 33;
    const cardW = pageWidth - marginLeft * 2;
    const cardH = 33;
    doc.setDrawColor(...borderColor);
    doc.setFillColor(...lightBg);
    doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
    doc.setDrawColor(0);

    const lblX_L = marginLeft + 3;
    const valX_L = marginLeft + 32;
    const baseY = cardY + 6;
    // L76 (2026-06) — Empresa hasta arriba
    drawLabel("Empresa:", empresa, lblX_L, valX_L, baseY);
    drawLabel("Fecha:", fecha, lblX_L, valX_L, baseY + 5);
    drawLabel("Proveedor:", proveedor, lblX_L, valX_L, baseY + 10);
    drawLabel(
      "Compra:",
      `# ${surtidos}${factura ? `  ·  Factura: ${factura}` : ""}`,
      lblX_L,
      valX_L,
      baseY + 15
    );
    drawLabel("Tipo:", tipo, lblX_L, valX_L, baseY + 20);

    const colRightX = pageWidth / 2 + 5;
    const lblX_R = colRightX;
    const valX_R = colRightX + 32;
    drawLabel(
      "Total Cantidad:",
      new Intl.NumberFormat("en-US").format(totalCantidad),
      lblX_R,
      valX_R,
      baseY
    );
    drawLabel(
      "Total Importe:",
      fmtMoney(totalImporte),
      lblX_R,
      valX_R,
      baseY + 5
    );
    drawLabel("Devolvió:", user || "", lblX_R, valX_R, baseY + 10);

    // L76 (2026-06) — Tabla unificada con Unidad en ambos tipos
    const head = isTela
      ? [["Tela", "Cantidad", "Unidad", "Precio", "Total"]]
      : [["Habilitación", "Cantidad", "Unidad", "Precio", "Total"]];

    doc.autoTable({
      head,
      body: bodyTabla,
      startY: cardY + cardH + 4,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 2,
        lineColor: borderColor,
        lineWidth: 0.1,
      },
      headStyles: {
        fillColor: brandColor,
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "left",
      },
      alternateRowStyles: { fillColor: stripeBg },
      columnStyles: {
        0: { cellWidth: "auto" },
        1: { cellWidth: 25, halign: "right" },
        2: { cellWidth: 25 },
        3: { cellWidth: 35, halign: "right" },
        4: { cellWidth: 35, halign: "right" },
      },
      // TF7 — si la compra lleva IVA: Subtotal + IVA (16%) + Total; si no, solo TOTAL
      foot: llevaIva
        ? [
            ["", "", "", "SUBTOTAL", fmtMoney(totalImporte)],
            ["", "", "", "IVA (16%)", fmtMoney(totalImporte * 0.16)],
            ["", "", "", "TOTAL", fmtMoney(totalImporte * 1.16)],
          ]
        : [["", "", "", "TOTAL", fmtMoney(totalImporte)]],
      footStyles: {
        fillColor: [255, 255, 255],
        textColor: 0,
        lineColor: borderColor,
        lineWidth: 0,
      },
      didParseCell: (h) => {
        if (h.section === "foot") {
          if (h.column.index === 3 || h.column.index === 4) {
            h.cell.styles.fillColor = brandColor;
            h.cell.styles.textColor = [255, 255, 255];
            h.cell.styles.fontStyle = "bold";
            h.cell.styles.halign = "right";
            h.cell.styles.lineWidth = 0.1;
          } else {
            h.cell.styles.lineWidth = 0;
          }
        }
      },
      showFoot: "lastPage",
    });

    // Observaciones (caja con label band) — solo si hay
    if (observaciones && observaciones !== "NA") {
      let finalY = doc.autoTable.previous.finalY + 6;
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, finalY, cardW, 6, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.text("OBSERVACIONES", marginLeft + 3, finalY + 4.2);
      doc.setTextColor(0);
      finalY += 6;
      doc.setFont(undefined, "normal");
      doc.setFontSize(9);
      const splitText = doc.splitTextToSize(observaciones, cardW - 12);
      const blockHObs = splitText.length * 4.2;
      doc.setFillColor(...lightBg);
      doc.setDrawColor(...borderColor);
      doc.rect(marginLeft, finalY, cardW, blockHObs + 5, "FD");
      doc.setDrawColor(0);
      doc.text(splitText, marginLeft + 3, finalY + 4);
    }

    // Footer paginado
    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let p = 1; p <= pageCount; p++) {
        doc.setPage(p);
        doc.setFontSize(8);
        doc.setTextColor(...labelColor);
        doc.text(
          `Devolución Proveedor #${numero}  ·  ${proveedor}  ·  Página ${p} de ${pageCount}`,
          pageWidth / 2,
          pageHeight - 5,
          { align: "center" }
        );
        doc.setTextColor(0);
      }
    } catch (errFooter) {
      console.warn("No se pudo dibujar footer:", errFooter);
    }

    doc.save(`DevolucionProveedor-${numero}.pdf`);
  } catch (err) {
    console.log(err);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "No se pudo generar el PDF.",
    });
  }
}

  // ============================================================================
  // PDFOCRollos — mismo estilo que PDFOC pero con el DETALLE DE CADA ROLLO
  // (agrupa por tela+color, cuenta rollos y desglosa la cantidad de cada rollo),
  // como el desglose de ListadoSurtidos de TextilesBasicos.
  // ============================================================================
  async function PDFOCRollos(
    fecha,
    idProveedor,
    proveedor,
    observaciones,
    numero,
    idPDFOC,
    user,
    surtidos,
    tipo,
    factura = "",
    empresa = ""
  ) {
    const brandColor = [42, 90, 138];
    const lightBg = [245, 247, 250];
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];

    const isTela = tipo === "Tela";
    const nf = (n) => new Intl.NumberFormat("en-US").format(Number(n) || 0);
    const fmtMoney = (n) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(Number(n) || 0);

    try {
      const authHeaders = {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      };

      // Los rollos reales están en InventariosTelas marcados con esta devolución.
      // Para Tela se listan uno por uno desde ahí (el acumulado los junta en 1).
      // Para Habilitación se usa el acumulado (no hay concepto de rollo).
      let rows = [];
      if (isTela) {
        const { data: rollos } = await axios.get(
          `${URL_INVENTARIOS_TELAS}/devolucionProveedorRollos/${idPDFOC}`,
          authHeaders
        );
        rows = (rollos || []).map((r) => ({
          descripcion: `${r.codigo || ""} ${r.nombre || ""}`.trim(),
          color: r.color || "NA",
          unidad: r.unidad || "",
          cantidad: Number(r.cantidad) || 0,
          costo: Number(r.costo) || 0,
        }));
      } else {
        const { data: lista } = await axios.get(
          `${URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS}/devolucionProveedor/${idPDFOC}`,
          authHeaders
        );
        rows = (lista || []).map((a) => {
          const h = a.habilitacion?.[0] || {};
          const cant = Number(a.cantidad) || 0;
          return {
            descripcion: `${h.nombre || ""} ${h.descripcion || ""}`.trim(),
            color: a.colores?.[0]?.name || "NA",
            unidad: h.unidad || "",
            cantidad: cant,
            costo: (Number(a.costo) || 0) * cant,
          };
        });
      }

      // Agrupar por descripción + color; cada renglón de rows es un rollo.
      const groups = {};
      rows.forEach((r) => {
        const cant = Number(r.cantidad) || 0;
        if (cant <= 0) return;
        const key = `${r.descripcion}||${r.color}`;
        if (!groups[key]) {
          groups[key] = {
            descripcion: r.descripcion || "—",
            color: r.color,
            unidad: r.unidad,
            rollos: 0,
            cantidad: 0,
            costo: 0,
            desgloce: [],
          };
        }
        groups[key].rollos += 1;
        groups[key].cantidad += cant;
        groups[key].costo += Number(r.costo) || 0;
        groups[key].desgloce.push(nf(cant));
      });

      const dataFinal = Object.values(groups).sort(
        (a, b) =>
          a.descripcion.localeCompare(b.descripcion) ||
          a.color.localeCompare(b.color)
      );

      if (!dataFinal.length) {
        Swal.fire(
          "Sin datos",
          "Esta devolución no tiene rollos para desglosar.",
          "info"
        );
        return;
      }

      const totalCantidad = dataFinal.reduce((t, c) => t + c.cantidad, 0);
      const totalRollos = dataFinal.reduce((t, c) => t + c.rollos, 0);
      const totalImporte = dataFinal.reduce((t, c) => t + c.costo, 0);

      setTotalMetrosEdit(
        dataFinal
          .filter((e) => e.unidad === "Metros")
          .reduce((t, c) => t + c.cantidad, 0)
      );
      setTotalKilosEdit(
        dataFinal
          .filter((e) => e.unidad === "Kilos")
          .reduce((t, c) => t + c.cantidad, 0)
      );

      const bodyTabla = dataFinal.map((g) => [
        g.descripcion,
        g.color,
        g.unidad,
        String(g.rollos),
        nf(g.cantidad),
        g.desgloce.join(" / "),
      ]);

      const doc = new jsPDF({ orientation: "landscape" });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginLeft = 15;

      const drawLabel = (label, value, lblX, valX, y) => {
        doc.setFont(undefined, "bold");
        doc.setFontSize(9);
        doc.setTextColor(...labelColor);
        doc.text(String(label || ""), lblX, y);
        doc.setFont(undefined, "normal");
        doc.setTextColor(0);
        doc.setFontSize(10);
        doc.text(String(value || "—"), valX, y);
      };

      // Header: logo + título + línea
      try {
        const img = new Image();
        img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        await new Promise((resolve) => {
          img.onload = () => {
            const maxH = 18;
            const scale = maxH / img.height;
            doc.addImage(img, "png", marginLeft, 6, img.width * scale, maxH);
            resolve();
          };
          img.onerror = () => resolve();
        });
      } catch (e) {}

      doc.setFont(undefined, "bold");
      doc.setFontSize(15);
      doc.setTextColor(...brandColor);
      doc.text(
        `DEVOLUCIÓN PROVEEDOR # ${numero} — DETALLE POR ROLLO`,
        pageWidth - marginLeft,
        18,
        { align: "right" }
      );
      doc.setDrawColor(...brandColor);
      doc.setLineWidth(0.6);
      doc.line(marginLeft, 30, pageWidth - marginLeft, 30);
      doc.setTextColor(0);
      doc.setLineWidth(0.2);
      doc.setDrawColor(0);

      // Card 2 columnas
      const cardY = 33;
      const cardW = pageWidth - marginLeft * 2;
      const cardH = 33;
      doc.setDrawColor(...borderColor);
      doc.setFillColor(...lightBg);
      doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
      doc.setDrawColor(0);

      const lblX_L = marginLeft + 3;
      const valX_L = marginLeft + 32;
      const baseY = cardY + 6;
      drawLabel("Empresa:", empresa, lblX_L, valX_L, baseY);
      drawLabel("Fecha:", fecha, lblX_L, valX_L, baseY + 5);
      drawLabel("Proveedor:", proveedor, lblX_L, valX_L, baseY + 10);
      drawLabel(
        "Compra:",
        `# ${surtidos}${factura ? `  ·  Factura: ${factura}` : ""}`,
        lblX_L,
        valX_L,
        baseY + 15
      );
      drawLabel("Tipo:", tipo, lblX_L, valX_L, baseY + 20);

      const colRightX = pageWidth / 2 + 5;
      const lblX_R = colRightX;
      const valX_R = colRightX + 34;
      drawLabel("Total Rollos:", String(totalRollos), lblX_R, valX_R, baseY);
      drawLabel(
        "Total Cantidad:",
        nf(totalCantidad),
        lblX_R,
        valX_R,
        baseY + 5
      );
      drawLabel("Total Importe:", fmtMoney(totalImporte), lblX_R, valX_R, baseY + 10);
      drawLabel("Devolvió:", user || "", lblX_R, valX_R, baseY + 15);

      const head = [
        [
          isTela ? "Tela" : "Habilitación",
          "Color",
          "Unidad",
          "Rollos",
          "Cantidad",
          "Desgloce Rollos",
        ],
      ];

      doc.autoTable({
        head,
        body: bodyTabla,
        startY: cardY + cardH + 4,
        theme: "grid",
        styles: {
          fontSize: 9,
          cellPadding: 2,
          lineColor: borderColor,
          lineWidth: 0.1,
          overflow: "linebreak",
        },
        headStyles: {
          fillColor: brandColor,
          textColor: [255, 255, 255],
          fontStyle: "bold",
          halign: "left",
        },
        alternateRowStyles: { fillColor: stripeBg },
        columnStyles: {
          0: { cellWidth: "auto" },
          1: { cellWidth: 32 },
          2: { cellWidth: 20 },
          3: { cellWidth: 18, halign: "right" },
          4: { cellWidth: 28, halign: "right" },
          5: { cellWidth: 95 },
        },
        foot: [["", "", "TOTAL", String(totalRollos), nf(totalCantidad), ""]],
        footStyles: {
          fillColor: [255, 255, 255],
          textColor: 0,
          lineColor: borderColor,
          lineWidth: 0,
        },
        didParseCell: (h) => {
          if (h.section === "foot") {
            if ([2, 3, 4].includes(h.column.index)) {
              h.cell.styles.fillColor = brandColor;
              h.cell.styles.textColor = [255, 255, 255];
              h.cell.styles.fontStyle = "bold";
              h.cell.styles.halign = "right";
              h.cell.styles.lineWidth = 0.1;
            } else {
              h.cell.styles.lineWidth = 0;
            }
          }
        },
        showFoot: "lastPage",
      });

      // Observaciones (caja con label band) — solo si hay
      if (observaciones && observaciones !== "NA") {
        let finalY = doc.autoTable.previous.finalY + 6;
        doc.setFillColor(...brandColor);
        doc.rect(marginLeft, finalY, cardW, 6, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFont(undefined, "bold");
        doc.setFontSize(9.5);
        doc.text("OBSERVACIONES", marginLeft + 3, finalY + 4.2);
        doc.setTextColor(0);
        finalY += 6;
        doc.setFont(undefined, "normal");
        doc.setFontSize(9);
        const splitText = doc.splitTextToSize(observaciones, cardW - 12);
        const blockHObs = splitText.length * 4.2;
        doc.setFillColor(...lightBg);
        doc.setDrawColor(...borderColor);
        doc.rect(marginLeft, finalY, cardW, blockHObs + 5, "FD");
        doc.setDrawColor(0);
        doc.text(splitText, marginLeft + 3, finalY + 4);
      }

      // Footer paginado
      try {
        const pageCount = doc.internal.getNumberOfPages();
        for (let p = 1; p <= pageCount; p++) {
          doc.setPage(p);
          doc.setFontSize(8);
          doc.setTextColor(...labelColor);
          doc.text(
            `Devolución Proveedor #${numero}  ·  ${proveedor}  ·  Detalle por rollo  ·  Página ${p} de ${pageCount}`,
            pageWidth / 2,
            pageHeight - 5,
            { align: "center" }
          );
          doc.setTextColor(0);
        }
      } catch (errFooter) {
        console.warn("No se pudo dibujar footer:", errFooter);
      }

      doc.save(`DevolucionProveedor-Rollos-${numero}.pdf`);
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo generar el PDF.",
      });
    }
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Proveedor", field: "proveedor", sortable: true },
    { name: "Compra", field: "Compras", sortable: true },
    { name: "Devolvio", field: "user", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
];

  const commentsData = useMemo(() => {
    let computedComments = comments

    if (search) {
        computedComments = computedComments.filter(
            comment =>
                comment.user.toLowerCase().includes(search.toLowerCase()) ||
                comment.proveedor.toLowerCase().includes(search.toLowerCase()) ||
                comment.compras.toString().includes(search)||
                comment.numero.toString().includes(search)
        );
    }
    if(selectedProveedor){
      computedComments = computedComments.filter((e)=>
      e.idProveedor.includes(selectedProveedor)
      ) 
    } 
    if(selectedUser){
      computedComments = computedComments.filter((e)=>
      e.idUser.includes(selectedUser)
      ) 
    } 

    if(selectedFechaInicio){
      computedComments = computedComments.filter((e)=>
      e.fecha >= selectedFechaInicio
      ) 
    }
  
    if(selectedFechaFin){
      computedComments = computedComments.filter((e)=>
      e.fecha <= selectedFechaFin
      ) 
    }


    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field && sorting.field != "compras" && sorting.field != "numero") {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (sorting.field && sorting.order === "asc" && (sorting.field == "compras" || sorting.field == "numero")) {
      computedComments = computedComments.sort(
        (a, b) => parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (sorting.field && sorting.order === "desc" && (sorting.field == "compras" || sorting.field == "numero")) {
      computedComments = computedComments.sort(
        (a, b) => parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
}, [comments, currentPage, search, sorting, selectedProveedor, selectedUser, selectedFechaInicio, selectedFechaFin]);


 
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_devolucionesProveedores ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.devolucionesProveedores_create ? (
                <>
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/DevolucionesProveedoresCreate"
                >
                  Nueva Devolucion Tela
                </Button>
                <Button
                size="sm"
                type="submit"
                className="btn btn-success"
                href="/DevolucionesProveedoresHabCreate"
              >
                Nueva Devolucion Hab
              </Button>
              </>
              ) : (
                <>
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Devolucion Tela
                </Button>
                <Button
                size="sm"
                type="submit"
                className="btn btn-success"
                disabled
              >
                Nueva Devolucion Hab
              </Button>
              </>
              )}
              <Button
                size="sm"
                href="/MenuCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Devolcuiones Proveedores</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Devoluciones Proveedores</h3>
          <div className="row">
                        <div className="col-md-8">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
                        <div className="col-md-4 d-flex flex-row-reverse">
                            <Search
                                onSearch={value => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                }}
                            />
                        </div>
                    </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Proveedores</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedProveedor}
                onChange={(e) => {
                  setSelectedProveedor(e.target.value)
                  setCurrentPage(1)
                }}
              >
                <option value="0">Selecciona</option>
                {proveedores
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>
            <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
                <TableHeader
                            headers={headers}
                            onSorting={(field, order) =>
                                setSorting({ field, order })
                            }
                        />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr>
                    <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.proveedor}</td>
                      <td>{a.compras}</td>
                      <td>{a.user}</td>
                      <td>
                          <Button
                          size="sm"
                          className="btn"
                          color="danger"
                          onClick={(e) => PDFOC(
                            a.fecha,
                            a.idProveedor,
                            a.proveedor,
                            a.observaciones,
                            a.numero,
                            a._id,
                            a.user,
                            a.compras,
                            a.tipo,
                            // L73 (2026-06)
                            a.factura,
                            a.empresa,
                            // TF7
                            a.llevaIva
                          )}
                        ><i class="far fa-file-pdf"></i>
                        </Button>
                        {" "}
                        <Button
                          size="sm"
                          className="btn"
                          color="info"
                          title="PDF detalle por rollo"
                          onClick={(e) => PDFOCRollos(
                            a.fecha,
                            a.idProveedor,
                            a.proveedor,
                            a.observaciones,
                            a.numero,
                            a._id,
                            a.user,
                            a.compras,
                            a.tipo,
                            a.factura,
                            a.empresa
                          )}
                        ><i class="fas fa-list-ol"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
        </div>
      ) : undefined}
      <br />


      

      {loader}
    </>
  );
}

export default ListadoDevolucionesProveedores;
